import { render } from "./healthAssessment.vue?vue&type=template&id=a7c62f48&scoped=true"
import script from "./healthAssessment.vue?vue&type=script&lang=js"
export * from "./healthAssessment.vue?vue&type=script&lang=js"

import "./healthAssessment.vue?vue&type=style&index=0&id=a7c62f48&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7c62f48"]])

export default __exports__